<template>
  <header class="header">
      
        <h2>Abecedario: Las letras</h2>
      
  </header>
</template>

<script>
    export default {
    }

</script>

<style scoped>
  p {
    color: white;
    font-size: 2rem;
  }
</style>